const Cookies = require('js-cookie');

export const SKIP_BLOCK_EDITABLE_LAST_MONTH_KEY = 'skipBlockEditableLastMonth';
export const SKIP_BLOCK_EDITABLE_LAST_MONTH_VALUE = 'true';

const getCookie = (name) => {
    return Cookies.get(name);
};

const cookieHelper = {
    getCookie,
};

export default cookieHelper;
